module.exports = __webpack_public_path__ + "img/security_camera.128431ff.jpg";